import React, {useState, useEffect, useLayoutEffect} from 'react'
import Color from '../../Components/Colors/Color'
import CustomSnackbar from "../Components/Snackbar/Snackbar"
import { useNavigate, useLocation } from 'react-router-dom';
import '../Components/Overlay/Overlay.css'
import ClipLoader from "react-spinners/ClipLoader"
import ProductData from '../../JSON/products.json'
import { jwtDecode } from "jwt-decode";
import '../Styles/AdminProductDetail.css'
import { deleteProduct, editProduct, fetchProductsDetail, uploadProductImage } from '../Controller/ProductController';

const AdminProductDetail = () => {

    const navigate = useNavigate();

    const urlLocation = useLocation();
    const queryParamsProduct = new URLSearchParams(urlLocation.search);
    const productIdUrl = queryParamsProduct.get('id');

    const [productId, setProductId] = useState("");
    const [product, setProduct] = useState({});
    const [name, setName] = useState("");
    const [image, setImage] = useState(null);
    const [list, setList] = useState([]);
    const [description, setDescription] = useState("");
    const [inputNum, setInputNum] = useState(1);
    const [imageLink, setImageLink] = useState("");

    const [loading, setLoading] = useState(false);
    const [loadingOverlay, setLoadingOverlay] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severitySnackbar, setSeveritySnackbar] = useState("");
    const [messageSnackbar, setMessageSnackbar] = useState("");
    const [success, setSuccess] = useState(false);
    const [failure, setFailure] = useState(false);
    const [finishFlag, setFinishFlag] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(0);
    const [emptyTokenFlag, setEmptyTokenFlag] = useState(false);
    const [imageChangeFlag, setImageChangeFlag] = useState(false);


    const [showOverlay, setShowOverlay] = useState(false);





    useEffect(() => {
        window.scrollTo(0,0);
        setProductId(productIdUrl)


        const handleFetchProductDetail = async () => {
            try{
                setLoading(true);
                const response = await fetchProductsDetail(productIdUrl);
                const status = response.status;

                if(status === 200){
                    const productFound = response.data.product;
                    console.log(productFound);
                    setProduct(productFound || {});
                    if(productFound){
                        setName(productFound?.name);
                        setImageLink(productFound?.imageLink);
                        setList(productFound?.productLists);
                        setDescription(productFound?.description);
                    }
                } else {
                    console.log("response" + response);
                    setSeveritySnackbar("error");
                    setMessageSnackbar(response?.data?.message || "An error has occurred");
                    setSnackbarDuration(3000);
                    setOpenSnackbar(true);                  
                }
    
            }catch(error)  {
                if(error?.response?.status === 404){
                    console.log("OLA");
                    setSeveritySnackbar("error");
                    setMessageSnackbar(error?.response?.data?.message || "No product found");
                    setSnackbarDuration(3000);
                    setSuccess(true);
                    setOpenSnackbar(true); 
                } else{
                    setMessageSnackbar(error?.response?.data?.message || "An error occurred")
                    setSeveritySnackbar("error");
                    setOpenSnackbar(true);
                }
            }finally{
                setLoading(false);
            }
        }

        handleFetchProductDetail();
    },[])

    useEffect(() => {
        if(!openSnackbar && emptyTokenFlag){
            setEmptyTokenFlag(false);
            localStorage.removeItem('authToken');
            navigate("/admin");
            return
        }
    }, [openSnackbar && emptyTokenFlag])

    useEffect(() => {
        if(!openSnackbar && success){
            setSuccess(false);
            navigate('/admin-dashboard');
        }

        if(!openSnackbar && failure){
            setFailure(false);
        }

        if(!openSnackbar && finishFlag){
            setFinishFlag(false);
        }
    }, [success && openSnackbar, failure && openSnackbar, finishFlag && openSnackbar]) 

    const handleCloseOverlay = () => {
        setShowOverlay(false);
    }

    const handleOpenOverlay = () => {
        if(!name){
            return;
        }
        setShowOverlay(true);
    }


    const onImageChange = (e) => {
        const file = e.target.files[0];
        setImage(file)
        console.log(file);
        if(file === undefined){
            setImage(null);
            setImageLink('');
        }
        if (file) {
            setImageLink(URL.createObjectURL(file));
            setImageChangeFlag(true);
            console.log(imageChangeFlag);
        }
    }

    const handleListChange = (e, index) => {
        e.preventDefault();
        const {value} = e.target;
        const listTemp = [...list];
        listTemp[index] = value;
        setList(listTemp);
        console.log(list);
    }

    const increaseInput = (e) => {
        e.preventDefault();
        setInputNum(inputNum + 1)
        setList([...list, ""]); // Add a new empty string to the listInput array
        console.log(inputNum);
    }

    const decreaseInput = (index) => {
        // if(inputNum < 2){
        //     return;
        // }
        const listTemp = list.filter((_, i) => i !== index);
        setList(listTemp);
        setInputNum(inputNum - 1);
    }

    const handleMoveBack = () => {
        navigate('/admin-dashboard')
    }

    // const tokenChecker = () => {
    //     let token = localStorage.getItem('authToken');
    //     if (!token) {
    //         setSeveritySnackbar("error");
    //         setMessageSnackbar("Token not found, please log in again!");
    //         setSnackbarDuration(3000);
    //         setOpenSnackbar(true);
    //         localStorage.removeItem('authToken');
    //         navigate("/admin");
    //         return null;
    //     }

    //     let decodedToken = jwtDecode(token);

    //     if (decodedToken && decodedToken.exp * 1000 > Date.now()){
    //         return;
    //     } else {
    //         setSeveritySnackbar("error");
    //         setMessageSnackbar("Token has expired, please log in again!");
    //         setSnackbarDuration(3000);
    //         setOpenSnackbar(true);
    //         localStorage.removeItem('authToken');
    //         navigate("/admin");
    //         return null;
    //     }
    // }

    function filterEmptyElements(list) {
        let tempList = list.filter(el => el !== '');
        return tempList.filter(el => el.name !== '');
    }

    const handleEditProduct = async (e) => {
        e.preventDefault();

        if(!imageLink){
            setSeveritySnackbar('error');
            setMessageSnackbar('Please provide an image');
            setSnackbarDuration(3000);
            setOpenSnackbar(true);
        }

        if(!name || !imageLink || !description) return;

        // tokenChecker();

        const filteredList = filterEmptyElements(list);
        setList(filteredList);

        const productImage = new FormData();
        productImage.append('imageFile', image);

        

        const product = {
            "name": name,
            "productLists": filteredList, 
            "description": description
        }

        try{
            setLoadingOverlay(true);

            const response = await editProduct(productId, product, imageChangeFlag);
         
            if(response.status === 200){
                if(imageChangeFlag){
                    const imageUploadResponse = await uploadProductImage(productImage, productId, false);
                    console.log(response);
                    console.log(imageChangeFlag);
                    if(imageUploadResponse.status === 200){
                        setSeveritySnackbar('success');
                        setSuccess(true);
                    } else {
                        await deleteProduct(response?.data?.productId);
                        setSeveritySnackbar('error');
                    }
                    setMessageSnackbar(imageUploadResponse?.data?.message);
                    setSnackbarDuration(3000);
                    setOpenSnackbar(true);
                } else {
                    setSeveritySnackbar('success');
                    setMessageSnackbar(response?.data?.message);
                    setSnackbarDuration(3000);
                    setSuccess(true);
                    setOpenSnackbar(true);
                }
            } else {
                console.log("response" + response);
                setSeveritySnackbar("error");
                setMessageSnackbar(response?.data?.message || "An error has occurred");
                setSnackbarDuration(3000);
                setFinishFlag(true);
                setOpenSnackbar(true);         
            }
            
        }   catch (error) {
            if(error?.response?.status === 404){
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "No product found");
                setSnackbarDuration(3000);
                setSuccess(true);
                setOpenSnackbar(true); 
            } else{
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "An error occurred, Please try again");
                setSnackbarDuration(3000);
                setFinishFlag(true);
                setOpenSnackbar(true);
            }
        } finally{
            setLoadingOverlay(false);
        }
    }

    const handleDeleteProduct = async(e) => {
        e.preventDefault();

        try{
            setLoadingOverlay(true);
            const response = await deleteProduct(productId);
            const status = response.status;
            if (status === 200) {

                setSeveritySnackbar("success");
                setMessageSnackbar(response?.data?.message);
                setOpenSnackbar(true);
                setSnackbarDuration(3000);
                setSuccess(true);
                
            } else if(response.status === 404){
                console.log("response" + response);
                setSeveritySnackbar("error");
                setMessageSnackbar(response?.data?.message || "No product found");
                setSnackbarDuration(3000);
                setSuccess(true);
                setOpenSnackbar(true); 
            }else {
                setSeveritySnackbar("error");
                setMessageSnackbar(response?.data?.message || "An error has occured, please try again");
                setFailure(false);
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
            }
        } catch (error) {
            if(error?.response?.status === 404){
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "No product found");
                setSnackbarDuration(3000);
                setSuccess(true);
                setOpenSnackbar(true); 
            } else {
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "An error occurred, Please try again");
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
            }

        } finally{
            setLoadingOverlay(false);
        }
    }

    const handleStopPropagation = (e) => {
        e.stopPropagation();
    }


    return(
        <>
            <div className='admin-product-detail-container' style={{backgroundColor: Color.secondaryText, color: Color.thirdText}}>
                <div className='admin-product-detail-header-container'>
                    <h4 className='admin-product-detail-header'>
                        Product Detail
                    </h4>
                    <div className='admin-product-detail-delete-btn-container'>
                        {/* <button className='admin-product-detail-delete-btn'> */}
                            {/* Delete */}
                            <span className='fa-solid fa-trash-can admin-product-detail-delete-btn' onClick={handleOpenOverlay}></span> 
                        {/* </button> */}
                    </div>
                </div>
                {(!loading && product) && 
                    <div className='admin-product-detail-contents'>
                        <div className='admin-product-detail-label-input-container'>
                            <label htmlFor='name' className='admin-product-detail-label'>
                                Name
                            </label>
                            <input 
                                type='text'
                                id='name'
                                className='admin-product-detail-input'
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            /> 
                        </div>
                        <div className='admin-product-detail-label-input-container'>
                            <label htmlFor='description' className='admin-product-detail-label'>
                                Description
                            </label>
                            <textarea
                                id='description'
                                className='admin-product-detail-input'
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                rows={7}
                                required
                            /> 
                        </div>
                        <div className='admin-product-detail-label-input-container'>
                            <label htmlFor='name' className='admin-product-detail-label'>
                                Product Lists
                            </label>
                            <div className='admin-product-detail-input-container'>
                                {list.map((input, index) => (
                                    <div className='admin-product-detail-input-container-inside'>
                                        <button className='admin-product-decrease-list-btn' onClick={() => decreaseInput(index)}>
                                            -
                                        </button>
                                        <input
                                            key={index}
                                            type="text"
                                            className="admin-product-detail-input"
                                            required
                                            onChange={(e) => handleListChange(e, index)}
                                            value={input.name}
                                        />
                                        
                                    </div>
                                ))}
                                <button className='admin-product-add-list-btn' onClick={(e) => increaseInput(e)}>
                                    +
                                </button>
                            </div>
                        </div>
                        <div className='admin-product-detail-label-input-container'>
                            <label htmlFor='image' className='admin-product-detail-label'>
                                Image
                            </label>
                            <input 
                                type='file'
                                id='image'
                                className='admin-product-detail-input image-input'
                                accept='.jpg, .jpeg, .png'
                                onChange={onImageChange}
                                required
                            /> 
                        </div>
                        {!imageLink ? ( 
                            <div className='admin-product-img-container'>
                                {/* <img src={imageLink} alt='product-image' className='admin-product-img' /> */}
                            </div>   
                        ): (
                            <div className='admin-product-img-container'>
                                <img src={imageLink} alt='product-image' className='admin-product-img' />
                            </div>
                        )     
                        }
                    </div>
                }

                <div className={`loading-container-overlay-small ${loading ? "" : "stop"}`}>
                    <ClipLoader size={100} color='black' />
                </div>

                <div className={`loading-container-overlay ${loadingOverlay ? "" : "stop"}`}>
                    <ClipLoader color='white' size={100} />
                </div>

                <div className='admin-product-detail-btn-container'>
                    <button className='admin-product-detail-cancel-btn' onClick={handleMoveBack}>
                        Cancel
                    </button>
                    <button className='admin-product-detail-save-btn' onClick={handleEditProduct}>
                        Save
                    </button>
                </div>
            </div>

            {showOverlay && (
            <div className="overlay-container" style={{color: 'black'}} onClick={() => setShowOverlay(false)}>
                <div className={`overlay-content`} onClick={handleStopPropagation}>
                    <h4 className={`delete-overlay-header`}>Product</h4>
                    <h6 className={`delete-overlay-text`}>Are you sure to delete the product?</h6>
                    <div className="delete-overlay-btn-container">
                        <button className={`delete-overlay-cancel-btn`} onClick={handleCloseOverlay}>
                            No
                        </button>
                        <button className="delete-overlay-ok-btn" onClick={handleDeleteProduct}>
                            Yes 
                        </button>
                    </div>
                    <div className={`loading-container-overlay ${loadingOverlay ? "" : "stop"}`}>
                            <ClipLoader color='white' size={100} />
                    </div>
                </div>
            </div>
        )} 

            <CustomSnackbar
                severity={severitySnackbar}
                message={messageSnackbar}
                open={openSnackbar}
                onClose={() => setOpenSnackbar(false)}
                time= {snackbarDuration}
            />
        </>
    )
}

export default AdminProductDetail;